import { FC, useState } from 'react';

import { BottomSlider } from 'components/_basic/BottomSlider';
import { AIAssistantAlertCard } from 'components/BusinessToolForm/components/AIAssistantAlertCard';

import { IAIGenerationErrorModalParentProps } from './types';
import { AIGenerationErrorModal } from '../AIGenerationErrorModal/AIGenerationErrorModal';

export const AIGenerationErrorModalParent: FC<IAIGenerationErrorModalParentProps> = ({ close, errorMessage }) => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [isSliderOpen, setIsSliderOpen] = useState(false);

  const handleSliderClose = () => {
    setIsSliderOpen(false);
    close();
  };

  return (
    <>
      {isModalVisible && (
        <AIGenerationErrorModal
          click={() => {
            setIsModalVisible(false);
            setIsSliderOpen(true);
          }}
          errorMessage={errorMessage}
          close={close}
        />
      )}
      <BottomSlider isOpened={isSliderOpen} onClose={handleSliderClose}>
        <AIAssistantAlertCard
          onCardClose={() => {
            handleSliderClose();
            close();
          }}
        />
      </BottomSlider>
    </>
  );
};
